import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from "react-router-dom";

//Components
import BrandWidget from '../components/Home/BrandWidget'
import CategoryWidget from '../components/Home/CategoryWidget'
import FeaturedProductWidget from '../components/Home/FeaturedProductWidget'
import PopularTodayWidget from '../components/Home/PopularTodayWidget'
import HomePageBanner from '../components/HomePageBanner'

//images
import phoneSS from '../static/logos/screenshot.png'

import Apple from '../static/appleStore.svg'
import Google from '../static/googleStore.svg'

import Up from '../static/up.png'
import OfferProductWidget from '../components/Home/OfferProductWidget';
import { getLocalData } from '../utils/localStorage';



function Home() {

  return (
    < >
        <section className=''>
            <div className="container">
              <div className='upload-pres'>
                <Row>
                  <Col md={8}>
                  <Col md={12}>
                    <h4>Upload your prescription and we’ll ship your medicines</h4>
                  </Col>
                  <Col md={12}>
                  <p>Our pharmacist will contact you to confirm your order and ship your meds</p>
                  </Col>
                  <Col md={4}>
                  <Link
                      className="btn btn-info address-form-button"
                      to={getLocalData("user-info")?.userToken?.length > 0 ? "/uploadprescription" : "/login"}
                    >
                      Upload Prescription
                    </Link>
                  </Col>
                  </Col>
                  <Col md={4}>
                    <div className="upload-back text-center">
                    <img src={Up} alt="sdsd" />
                    </div>
                  
                  </Col>
                  
                </Row>
                
              </div>

            </div>
        </section>
        <HomePageBanner/>
        
        <CategoryWidget/>
        <BrandWidget/>
        <section id="download-apps" className='download-showcase'>
         
            <div className='container'>
              <Row className='row-app-section'>
              <img className='screenshot-home-app' alt="sceenshot" src={phoneSS}/>

                <Col  md={12}  className='text-center'>
                  <span  className='header-app-section'>Explore whole new experience</span>
                </Col>
                <Col  md={12}  className='text-center'>
                  <span  className='text-app-section'>Order & track your medicines on the move </span><br/>
                  <span  className='text-app-section'>Download the App now </span>
                </Col>
                <Col  md={12} className='app-button-center'>
                {
                  process.env.REACT_APP_DEFAULT_APPLESTOER_LINK !== '#' && (
                    <a href={`${process.env.REACT_APP_DEFAULT_APPLESTOER_LINK}`} target="_blank" className='app-btton d-flex'> 
                    <img src={Apple} alt="apple"/> 
                    <div className='app-buttons-inner'>
                      <span className='top-text'>Download on the</span>
                      <span className='bottom-text'>App Store</span>
                    </div>

                    </a> 
                  )
                }{
                  process.env.REACT_APP_DEFAULT_GOOGLEPLAY_LINK !== '#' && (
                    <a href={`${process.env.REACT_APP_DEFAULT_GOOGLEPLAY_LINK}`} target="_blank" className='app-btton d-flex'>
                    <img src={Google} alt="google"/> 
                      <div className='app-buttons-inner'>
                      <span className='top-text'>Get it on</span>
                        <span className='bottom-text'>Google Play</span>
                      </div>
                       </a>
                  )
                }
                  
                 
                </Col>
                
             
                
                
              </Row>
            </div>
        </section>
        <FeaturedProductWidget/>
        <OfferProductWidget/>
        <PopularTodayWidget />
    </>
  )
}

export default Home